import { AttributeOverrideRow } from 'src/app/models/attribute-override-row';

export class AttributeOverrideDialogResult {
    public constructor(
        public confirmation: boolean,
        public value: AttributeOverrideRow = null
    ) {}
}
